var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"logo",attrs:{"alt":"Buy Nice Cards","src":`${_vm.baseUrl}img/logo.png`}})
}
var staticRenderFns = []

export { render, staticRenderFns }